export const TimesheetFormulaEN = {
  "formulaTitle": {
    "valueRequire" : "Enter value",
    "calculationRequire" : "Calculation method is a required field!",
    "calculationToolTip" : "Standard working days will be reduced by the number of company/organization leave days in the month as set in Holiday Settings",
    "formulaValueRequire" : "Enter formula/value",
    "keywordRequire" : "Enter keyword",
    "column_cell" : "Enter column/cell",
    "changeRequire" : "Select change",
    "tableRequire" : "Select table",
    "timekeepingFormula" : "Timesheet formula",
    "standardWorkday" : "Standard workday",
    "table" : "Table",
    "change" : "Change",
    "nameCell" : "Name column/cell",
    "keyword" : "Keyword",
    "formula" : "Formula/value",
    "result" : "Result",
    "description" : "Description",
    "calculation" :  "Caculation",
    "value" : "Value",
    "department" : "Department ",
    "jobPosition" : "Job position",
    "note" : "Note",
    "automaticDate" : "Automatic recalculation of the work table",
    "columnKeyword" : "Column",
    "name" : "Name",
    "default" : "default value",
    "example" : "Example",
    "noteKeyword" : "Note"
  },
  "tabFormula": {
    "SHIFT_KEYWORD": "General settings",
    "KEYWORD": "Shift keywords",
    "DATE_KEYWORD": "Date keywords",
    "OVERTIME_KEYWORD": "Overtime keywords",
    "MISSION_KEYWORD": "Mission keywords",
    "HOURLY_LEAVE_KEYWORD": "Hourly leave keywords",
    "MONTHLY_APPLICATION_KEYWORD": "Month application keywords",
    "CHECK_IN/OUT_KEYWORD": "Checkin/out keywords"
  },
  "formulaPlaceholder": {
    "formula" : "formulas starting with =",
    "table" : "Select table",
    "change" : "Select change",
    "cellColumn" : "Name coloumn/cell",
    "keyword" : "Keyword",
    "valueFormula" : "Value or formula",
    "result" : "Number/text",
    "description" : "Description",
    "calculation" :  "Calculation",
    "value" : "Value is number",
    "department" : "Department ",
    "jobPosition" : "Job position",
    "note" : "You can note the content of the timekeeping regulations here ",
    "informationNote0" : "Instructions: ",
    "informationNote1" : "Formula/value written completely like excel . ",
    "informationNote2" : "Example : ",
    "informationNote3" : "IF( LATE_SHIFT > 90,1,0) . ",
    "informationNote4" : "In addition, to use statistical functions, you can use reference formulas with table names: ",
    "informationNote5" : " monthly summary and personnel information ",
    "informationNote6" : " Worksheet for all shifts ",
    "informationNote7" : " Worksheets for all days",
    "informationNote8" : " Worksheet for all overtime shifts ",
    "informationNote9" : " missions sheet",
    "informationNote10" : " meeting sheet ",
    "informationNote11" : "Ví dụ: ",
    "informationNote12" : "=COUNT( SHIFTS!LATE_MINUTE > 10 ) ",
    "informationNote13" : "return tardies greater than 10 minutes in a month",
    "informationDate0" : "When you select the calculation period from the month, only automatic recalculation will be applied for that time onwards. ",
    "informationDate1" : "Example: If you choose from June 2021, the company will automatically recalculate from June onwards, if you do not select it, it will calculate the last 2 months. (Applicable only to unfinished work sheets)"
  },
  "typeArray" : {
    "month" : "MONTH",
    "date" : "DATES" ,
    "shift" : "SHIFTS",
    "overtime" : "OVERTIMES",
    "meeting" : "MEETINGS ",
    "mission" : "MISSIONS",
    "checkin/out" : "CHECKINOUTS",
    "formula" : "Formula",
    "ColumnNew" : "Column New",
    "RowNew" : "Row New",
    "number" : "Number type",
    "text" : "Text type",


    "other": "Fixed days",
    "subSunday": "Total days in the timesheet excluding Sundays",
    "subSaturday": "Total days in the timesheet excluding Saturdays",
    "subSaturdaySunday": "Total days in the timesheet excluding Saturdays and Sundays",
    "subHalfSaturdayAndSunday": "Total days in the timesheet excluding half-day Saturday and half-day Sunday",
    "subHalfSaturdaySunday": "Total days in the timesheet excluding half-day Saturday and full-day Sunday",
    "subSaturdayHalfSunday": "Total days in the timesheet excluding full-day Saturday and half-day Sunday",
    "subHalfNDay": "Total days in the timesheet excluding N days",
    "totalShift": "Total assigned shifts in the shift schedule"

  },
  "actionFormula": {
    "update" : "Update",
    "cancel" : "Cancel",
    "error" : "value must be numeric and greater than 0"
  }
}